var React = require('react');

function External (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M5 21c-.55 0-1.02083-.1958-1.4125-.5875C3.19583 20.0208 3 19.55 3 19V5c0-.55.19583-1.02083.5875-1.4125C3.97917 3.19583 4.45 3 5 3h6c.5523 0 1 .44772 1 1s-.4477 1-1 1H5v14h14v-6c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .55-.1958 1.0208-.5875 1.4125C20.0208 20.8042 19.55 21 19 21H5Zm5.4-6c-.3866.3866-1.0134.3866-1.4 0-.3866-.3866-.3866-1.0134 0-1.4L17.6 5H15c-.5523 0-1-.44772-1-1s.4477-1 1-1h5c.5523 0 1 .44772 1 1v5c0 .55228-.4477 1-1 1s-1-.44772-1-1V6.4L10.4 15Z"})));
}

External.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = External;

External.default = External;
